<app-only-table-generator
    [tableInput]="tableGenInputs"
    [tableData]="tableData"
></app-only-table-generator>
